<template>
    <div class="con">
        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>

        <div class="main wow fadeInUp" :style="bStyle">
            <div class="nav">
                <span v-for="(item,index) in $t('about').navList" :key="index" :class="{'showLine':select===index}" @click="change(index)">{{item}}</span>
            </div>
        </div>

        <div class="mainCon" id="gs">
            <img class="big" src="../assets/home/junan.png" alt="">
            <div class="content wow fadeInUp" >
                <div class="left">
                    <p class="a">{{$t('about').navList2[0]}}</p>
                    <p class="b">君行正道 安積德義</p>
                    <dia-Component></dia-Component>
                    <div class="threeText" ref="counts" :class="{'enthree':$i18n.locale === 'en'}">
                        <div class="item">
                            <div class="t">
                                <span id="num1">2001</span>
                                <span style="line-height: 10px;"></span>
                            </div>
                            <span class="small">{{$t('home').three[0]}}</span>
                        </div>
                        <div class="item">
                            <div class="t">
                                <span id="num2">15000</span>
                                <span style="line-height: 10px;">{{$t('home').three[1]}}</span>
                            </div>
                            <span class="small">{{$t('home').three[2]}}</span>
                        </div>
                        <div class="item">
                            <div class="t">
                                <span id="num3">90000</span>
                                <span style="line-height: 10px;">{{$t('home').three[3]}}</span>
                            </div>
                            <span class="small">{{$t('home').three[4]}}</span>
                        </div>
                        <div class="item">
                            <div class="t">
                                <span id="num4">2000000</span>
                                <span style="line-height: 10px;">{{$t('home').three[1]}}</span>
                            </div>
                            <span class="small">{{$t('home').three[5]}}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <p>junan holdings.</p>
                    <div class="swiper">
                        <swiper :options="swiperOption" ref="mySwiper" v-if="list.length>1">
                            <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                                <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="">
                            </swiper-slide>
                        </swiper>
                        <div class="btn prev ">
                        <i class="iconfont icon-xiangshang"></i>
                        </div>
                        <div class="btn next " >
                            <i class="iconfont icon-xiangshang"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="history" id="ls">
            <img src="../assets/about/h.png" alt="" >
            <div class="hCon">
              <p class="title wow fadeInUp" >{{$t('about').navList2[1]}}</p>
                <div class="m wow fadeInUp">
                    <swiper class="swiper" :options="swiperOption2" ref="mySwiper">
                        <swiper-slide class="item" v-for="(item,index) in hList" :key="index">
<!--                         <div class="l">-->

<!--                         </div>-->
<!--                            <div class="c">-->
<!--                               <p>{{item.TITLE}}</p>-->
<!--                                <span></span>-->
<!--                            </div>-->
<!--                            <div class="r">-->

<!--                            </div>-->
                                  <div class="ha">
                                      <div class="one">
                                          <div class="o">
                                              <span></span>
                                              <span>{{item.TITLE}}</span>
                                          </div>
                                          <div class="r">
                                              <p>development</p>
                                              <p>history</p>
                                          </div>
                                      </div>
                                      <div class="two">
                                          <p class="time">{{item.TITLE}}</p>
                                          <div class="htmlCon" v-html="item.CON">

                                          </div>
                                      </div>
                                  </div>
                        </swiper-slide>
                    </swiper>
                    <div class="btn prev ">
                        <i class="iconfont icon-xiangshang"></i>
                    </div>
                    <div class="btn next">
                        <i class="iconfont icon-xiangshang"></i>
                    </div>
<!--                    <div class="ca" :class="{'isAll':a}">-->
<!--                        <div class="one">-->
<!--                            <div class="o">-->
<!--                                <span></span>-->
<!--                                <span>{{hInfo.TITLE}}</span>-->
<!--                            </div>-->
<!--                            <div class="r">-->
<!--                                <p>development</p>-->
<!--                                <p>history</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="two">-->
<!--                            <p class="time">{{hInfo.SHOWTIME}}</p>-->
<!--                            <div class="htmlCon" v-html="hInfo.CON">-->

<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

            </div>
        </div>

        <div class="leader" id="ld">
            <div class="ml">
                <p class="t wow fadeInUp" :class="{'ent':$i18n.locale === 'en'}">{{$t('about').navList2[2]}}</p>
                <div class="allNews">
                 <div class="item" v-for="(item,index) in leList" :key="index">
                     <router-link :to="{path: 'ldInfo',query:{id:item.ID}}" target="_blank">
                     <div class="i1">
                         <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                     </div>
                     <p>{{item.TITLE}}</p>
                     </router-link>
                 </div>
                </div>
                <div style="text-align: center;margin-top: 60px;" @click="showMore">
                    <span>{{$t('about').text2}}</span>
                    <btn-Component></btn-Component>
                </div>
            </div>

        </div>

        <div class="ry" id="ry" :class="{'enry':$i18n.locale === 'en'}">
            <img class="bg" src="../assets/about/r.png" alt="">
            <div class="a">
            <p class="t wow fadeInUp">{{$t('about').navList2[3]}}</p>
                <div class="items wow fadeInUp" :class="{'enItems':$i18n.locale === 'en'}">
                <div class="item">
                    <p>{{$t('about').honor[0]}}</p>
                   <p> {{$t('about').honor[1]}}</p>
                    <p>{{$t('about').honor[2]}}</p>
                </div>
                    <div class="item">
                        <p>{{$t('about').honor[3]}}</p>
                        <p>{{$t('about').honor[4]}}</p>
                        <p>{{$t('about').honor[5]}}</p>
                    </div>
                    <div class="item b">
                        <p>{{$t('about').honor[6]}}</p>
                        <p>{{$t('about').honor[7]}}</p>
                    </div>
                </div>
                <div class="allImg wow fadeInUp">
                    <swiper class="swiper" :options="swiperOption3" ref="mySwiper" v-if="rList.length>1">
                    <swiper-slide class="item" v-for="(item,index) in rList" :key="index">
                        <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="" @click="show(item.PICURL)">
                        <p>{{item.PICNAME}}</p>
                    </swiper-slide>
                </swiper>
                    <swiper class="swiper swiper2" :options="swiperOption4" ref="mySwiper2">
                        <swiper-slide class="item" v-for="(item,index) in rList" :key="index">
                            <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="" @click="show(item.PICURL)">
                            <p>{{item.PICNAME}}</p>
                        </swiper-slide>
                    </swiper>
                        <div class="btn prev ">
                            <i class="iconfont icon-you1"></i>
                        </div>
                        <div class="btn next">
                        <i class="iconfont icon-you1"></i>
                    </div>
                </div>
            </div>
            <div class="bigImg" v-if="showBig" @click="hide">
                <img :src="src" alt="">
            </div>
        </div>

        <div class="jg wow fadeInUp" id="jg">
            <img class="bbb"  src="../assets/about/jg.png" alt="">
            <div class="add">
                <p class="title wow fadeInUp">{{$t('about').navList2[4]}}</p>
                <viewer :images="bigList" >
                    <img v-for="item in bigList" :src="item.url" :key="item.index">
                </viewer>
            </div>
        </div>



        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import footComponent from '../components/foot'
    import btnComponent from '../components/btn'
    import  diaComponent from '../components/aboutDia2'
    import { CountUp } from 'countup.js'
    import Scrollbar from 'smooth-scrollbar'
    import { getPicUrl,getNewsUrl} from '../util/lang'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "about",
        data(){
            const _this=this
            return{
                page:'',
                id:'',
                totalPage:'',
                leList:[],
                bigList:[{url:require('../assets/about/l.png')}],
                src:'',
                showBig:false,
                bStyle:{},
                a:false,
                activeIndex:'',
                hInfo:{
                    TITLE:'',
                    NOTETIME:'',
                    CON:''
                },
                rList:[],
                hList:[],
                swiperOption3:{
                    notNextTick: true,
                    slidesPerView: 3,
                    speed:1000,
                    loop: true,
                    autoplay:false,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.allImg .btn.prev',
                        nextEl: '.allImg .btn.next',
                    }
                },
                swiperOption4:{
                    notNextTick: true,
                    slidesPerView: 1,
                    speed:1000,
                    loop: true,
                    autoplay:false,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.allImg .btn.prev',
                        nextEl: '.allImg .btn.next',
                    }
                },
                swiperOption2:{
                    notNextTick: true,
                    slidesPerView: 1,
                    speed:2000,
                    setWrapperSize :true,
                    autoHeight :true,
                    navigation: {
                        prevEl: '.hCon .btn.prev',
                        nextEl: '.hCon .btn.next',
                    },
                    on: {
                        slideChangeTransitionEnd: function(){
                            _this.activeIndex = this.realIndex;
                            _this.hInfo=  _this.hList[this.realIndex]
                            _this.a=true
                            setTimeout(()=>{
                                _this.a=false
                            },600)
                        },
                    }
                },
                swiperOption:{
                    direction: 'vertical',
                    height: 500,
                    speed:1000,
                    loop: true,
                    autoplay:false,
                    navigation: {
                        prevEl: '.right .btn.prev',
                        nextEl: '.right .btn.next',
                    }
                },
                select:0,
                list:[],
                navList:[
                    '君安概述',
                    '君安沿革',
                    '领导关怀',
                    '企业荣誉',
                    '组织架构'
                ],
                info:{
                    img:require('../assets/about/ban.png'),
                    text0:'走进君安',
                    text1:'君行正道  安積德義'
                },
                scrollbar:'',
                top:''
            }
        },
        components:{banComponent,footComponent,diaComponent,swiper, swiperSlide,btnComponent},
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,0)
            this.count()
            this.getImgList()
            this.getImg2List()
            if( this.$i18n.locale === 'en'){
                this.info={
                    img:require('../assets/about/ban.png'),
                        text0:'ABOUT US',
                        text1:'君行正道  安積德義'
                }
                this.bigList[0].url=require('../assets/ena.png')
                this.getNews('36')
                this.getLd('37')
            }else{
                this.getNews('29')
                this.getLd('30')
            }
            if(this.$route.query.index!==undefined){
                this.change(parseInt(this.$route.query.index-1))
            }
        },
        methods:{
            hide(){
                this.showBig=false
                this.scrollbar.scrollTo(0,this.top)
            },
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,6,this.page++)}`
                        this.$axios.get(url).then(res => {
                            // res.data.newsArr.map((item)=>{
                            //     item.SHOWTIME=item.SHOWTIME.slice(0,11)
                            // })
                            this.leList= this.leList.concat(res.data.newsArr)
                        })

                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            show(n){
                this.top=this.scrollbar.scrollTop
                Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#ry"))
                this.src='http://junankg.com/upload/'+n
                this.showBig=true
            },
            getImgList(){
                const url = `${getPicUrl(this.$i18n.locale,'走进君安',1000)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data
                })
            },
            getImg2List(){
                const url = `${getPicUrl(this.$i18n.locale,'企业荣誉',1000)}`
                this.$axios.get(url).then(res => {
                    this.rList=res.data
                    console.log(res.data)
                })
            },
            getLd(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    // res.data.newsArr.map((item)=>{
                    //     item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    // })
                    this.leList=res.data.newsArr
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            },
            getNews(id){
                const url = `${getNewsUrl(this.$i18n.locale,id,1000,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    })
                    this.hList=res.data.newsArr
                    this.hInfo=this.hList[0]
                    this.$refs.mySwiper.swiper.init()
                    this.$refs.mySwiper2.swiper.init()
                })
            },
            change(n){
                this.select=n
                if(n===0){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#gs"))
                }else if(n===1){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#ls"))
                }else if(n===2){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#ld"))
                }else if(n===3){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#ry"))
                }
                else{
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#jg"))
                }
            },
            count(){
                let element=this.$refs.counts;
                let actualTop = element.offsetTop;
                let current = element.offsetParent;
                while (element=element.offsetParent){
                    actualTop += element.offsetTop;
                    /* current = current.offsetParent; */
                }
                let demoFi1 = new CountUp("num1", 2001);
                let demoFi2 = new CountUp("num2", 15000);
                let demoFi3 = new CountUp("num3", 90000);
                let demoFi4 = new CountUp("num4", 2000000);
                let numok=false;
                let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
                if(scrollbar){
                    scrollbar.addListener((status) => {
                        // if(status.offset.y>document.body.clientHeight){
                        //     this.bStyle={top:status.offset.y+68+'px',border:'none'}
                        // }else{
                        //     this.bStyle={top:'100vh'}
                        // }
                        if(!numok){
                            if(actualTop<status.offset.y+document.body.clientHeight){
                                demoFi1.start();
                                demoFi2.start();
                                demoFi3.start();
                                demoFi4.start();
                                numok=true;
                            }
                        }
                    });
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    position: relative;
    .main{
        width:100%;
        background-color: rgba(255,255,255,.8);
        padding: 1px 0;
        border-bottom: 1px solid rgba(0,0,0,.2);
        .nav{
            width:1280px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content:center;
            span{
                display: inline-block;
                padding: 15px 80px;
                cursor: pointer;
                transition: all 2s;
                font-size: 15px;
                text-transform: uppercase;
            }
            span:hover{
                background-color: #0068B7;
                color:white;
            }
            .showLine{
                background-color: #0068B7;
                color:white;
            }
        }
    }
    .mainCon{
        width:100%;
        padding-bottom: 100px;
        .big{
            width:90%;
            margin-left: 10%;
            object-fit: cover;
        }
        .content{
            width:1280px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            margin-top: -260px;
            .left{
                width:55%;
                display: flex;
                flex-direction: column;
                .a{
                    font-size: 25px;
                    color:#444546;
                    font-weight: bold;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #828282;
                    width:60%;
                    position: relative;
                }
                .a::before{
                    position: absolute;
                    content:'';
                    display: inline-block;
                    width:30%;
                    background-color: #3B95FF;
                    height:1px;
                    left:0;
                    bottom:0;
                }
                .b{
                    font-size: 25px;
                    font-weight: bold;
                    background:linear-gradient(to right, #002762, #1E9AD0);
                    -webkit-background-clip: text;
                    color: transparent;
                  padding: 40px 0;
                }
                .threeText{
                    width:95%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 100px;
                    font-family: "Microsoft YaHei UI";
                    .item{
                        display: flex;
                        flex-direction: column;
                        text-align: center;
                        .t{
                            position: relative;
                            padding-right: 10px;
                            padding-left: 10px;
                            padding-bottom: 10px;
                            span:first-child{
                                font-size: 30px;
                                color:#444546;
                               font-weight: bolder;
                            }
                            span:last-child{
                                position: absolute;
                                top:-5px;
                                right:-20px;
                                font-size: 12px;
                            }
                        }
                        .small{
                            font-size: 14px;
                            color:#444546;
                        }
                    }
                }
                .enthree{
                    flex-wrap: wrap;
                    margin-top: 50px;
                    .item{
                        width:50%;
                        margin-top: 30px;
                    }
                }
            }
            .right{
                display: flex;
                flex-direction: row;
                position: relative;
                width:42%;
                margin-left: 3%;
                padding-top: 160px;
                p{
                    text-transform: uppercase;
                    font-size: 18px;
                    font-weight: bold;
                    color:rgba(68, 69, 70, .2);
                    position: absolute;
                    bottom:0;
                    left:10px;
                    transform: rotate(-90deg);
                    transform-origin: left;
                }
                .swiper{
                  width:90%;
                    margin-left: 5%;
                    height:500px;
                   overflow: hidden;
                    position: relative;
                   .item{
                       width:100%;
                       height:100%;
                       img{
                           width:100%;
                           object-fit: cover;
                           height:100%;
                           display: block;
                       }
                   }
                    .prev{
                        position: absolute;
                        left:0;
                        top:45%;
                        height:40px;
                        width:40px;
                        z-index: 1000;
                        color:#0068B7;
                        cursor: pointer;
                        background-color: white;
                        line-height: 40px;
                        text-align: center;
                        transition: all 2s;
                        transform: rotate(180deg);
                    }
                    .next{
                        position: absolute;
                        left:0;
                       top:55%;
                        height:40px;
                        width:40px;
                        z-index: 1000;
                        color:#0068B7;
                        background-color: white;
                        cursor: pointer;
                        text-align: center;
                        line-height: 40px;
                        transition: all 2s;
                    }
                    .prev:focus{
                        outline: none;
                    }
                    .next:focus{
                        outline: none;
                    }
                    .prev:hover{
                          background-color: #3B95FF;
                        color:white;
                      }
                    .next:hover{
                        background-color: #3B95FF;
                        color:white;
                    }
                }
            }
        }
    }
    .history{
        width:100%;
        position: relative;
        img{
            width:100%;
            object-fit: cover;
            display: block;
        }
        .hCon{
            width:100%;
            position: absolute;
            top:60px;
            left:0;
            .title{
                text-align: center;
                width:30%;
                margin-left: 35%;
                font-size: 24px;
                font-weight: bold;
                padding-top: 30px;
                color:white;
                padding-bottom: 40px;
                border-bottom: 1px solid rgba(255,255,255,.3);
                position: relative;
            }
            .title::before{
                position: absolute;
                content:'';
                display: inline-block;
                background-color:#0068B7;
                left:35%;
                bottom:-1px;
                width:30%;
                height:2px;
            }
            .m{
                width:100%;
                margin-top: 100px;
               position: relative;
                .swiper{
                    width:90%;
                    margin-left: 5%;
                    .item{
                        position: relative;
                        .ha{
                            width:30%;
                            margin: 0 auto;
                            .one{
                                background:linear-gradient(to right, #07467E, #057FC0);
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                padding: 40px 20px;
                                color:white;
                                .o{
                                    padding-left: 20px;
                                    span:nth-child(1){
                                        display: inline-block;
                                        height:19px;
                                        width:19px;
                                        border: 1px solid white;
                                        border-radius: 50%;
                                        position: relative;
                                    }
                                    span:nth-child(1)::before{
                                        display: inline-block;
                                        height:13px;
                                        width:13px;
                                        left:3px;
                                        top:3px;
                                        content:'';
                                        background-color: white;
                                        border-radius: 50%;
                                        position: absolute;
                                    }
                                    span:nth-child(2){
                                        font-size: 35px;
                                        font-weight: bolder;
                                        padding-left: 20px;
                                    }
                                }
                                .r{
                                    text-transform: uppercase;
                                    text-align: right;
                                    line-height: 30px;
                                }
                            }
                            .two{
                                background-color: white;
                                padding: 40px 40px;
                                line-height: 30px;
                                .time{
                                    color:#010101;
                                    font-weight: bolder;
                                    padding-bottom: 30px;
                                }
                                .htmlCon{
                                    width:100%;
                                    font-size: 14px;
                                    overflow: hidden;
                                }
                            }
                        }
                    }
                    .item::before{
                             position: absolute;
                             content:'';
                             display: inline-block;
                             height:1px;
                             width:33%;
                             top:42%;
                             left:1%;
                             background-color: #fff;
                         }
                    .item::after{
                        position: absolute;
                        content:'';
                        display: inline-block;
                        height:1px;
                        width:33%;
                        top:42%;
                        right:1%;
                        background-color: #fff;
                    }
                }
                .prev{
                    position: absolute;
                    left:2.5%;
                    top:37%;
                    color:white;
                    padding:5px 5px;
                    transform: rotate(90deg);
                    cursor: pointer;
                    transition: all 2s;
                }
                .next{
                    position: absolute;
                    right:2.5%;
                    top:37%;
                    color:white;
                    padding:5px 5px;
                    transform: rotate(-90deg);
                    cursor: pointer;
                    transition: all 2s;
                }
                .btn:hover{
                    color:#3B95FF;
                }
                .btn:focus{
                    outline: none;
                }
                .ca{
                        position: absolute;
                        left:35%;
                        top:-145%;
                        width:30%;
                        z-index: 100;
                    .one{
                        background:linear-gradient(to right, #07467E, #057FC0);
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        padding: 40px 20px;
                        color:white;
                        .o{
                            padding-left: 20px;
                            span:nth-child(1){
                                display: inline-block;
                                height:19px;
                                width:19px;
                                border: 1px solid white;
                                border-radius: 50%;
                                position: relative;
                            }
                            span:nth-child(1)::before{
                                display: inline-block;
                                height:13px;
                                width:13px;
                                left:3px;
                                top:3px;
                                content:'';
                         background-color: white;
                                border-radius: 50%;
                                position: absolute;
                            }
                            span:nth-child(2){
                                font-size: 35px;
                                font-weight: bolder;
                                padding-left: 20px;
                            }
                        }
                        .r{
                            text-transform: uppercase;
                            text-align: right;
                            line-height: 30px;
                        }
                    }
                    .two{
                        background-color: white;
                        padding: 40px 40px;
                        line-height: 30px;
                        .time{
                            color:#010101;
                            font-weight: bolder;
                            padding-bottom: 30px;
                        }
                        .htmlCon{
                            width:100%;
                            font-size: 14px;
                            overflow: hidden;
                        }
                    }
                    }
                .isAll{
                    opacity: 0;
                    animation: show 100ms forwards;
                }
                @keyframes show {
                    from{
                        opacity: 0;
                    }
                    to{
                        opacity: 1;
                    }
                }
            }
        }
    }
    .leader{
        width:100%;
        padding: 60px 0;
        .ml{
            width:1280px;
            margin: 0 auto;
            .t{
            width:30%;
                margin-left: 35%;
            font-size: 30px;
            font-weight: bolder;
            padding-bottom: 30px;
            border-bottom: 1px solid rgba(0,0,0,.3);
            position: relative;
                text-align: center;
        }
            .t::before{
                position: absolute;
                left:35%;
                bottom:-1px;
                width:30%;
                background-color: #0068B7;
                height:1px;
                content:'';
                display: inline-block;
            }
            .allNews{
                width:100%;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .item{
                    width:26%;
                    margin-left: 5%;
                    margin-top: 40px;
                    cursor: pointer;
                    .i1{
                        width:100%;
                        overflow: hidden;
                        padding: 10px 10px;
                        border: 1px solid rgba(0,0,0,.2);
                        text-align: center;
                        img{
                            width:85%;
                            object-fit: cover;
                            transition: all 1s;
                        }
                    }
                    p{
                        text-align: center;
                        padding: 10px 0;
                        transition: all 1s;
                        color:black;
                    }
                }
                .item:hover{
                    .i1{
                        img{
                            transform: scale(1.05);
                        }
                    }
                    p{
                        color: #0068B7;
                    }
                }
            }
        }
    }
    .ry{
        width:100%;
        position: relative;
        .bg{
            width:100%;
            object-fit: cover;
            display: block;
        }
        .a{
            width:1280px;
            position: absolute;
            left:17%;
            top:0;
            display: flex;
            flex-direction: column;
            padding: 80px 0;
            .t{
                width:30%;
                font-size: 30px;
                font-weight: bolder;
                padding-bottom: 30px;
                border-bottom: 1px solid rgba(0,0,0,.3);
                position: relative;
            }
            .t::before{
                position: absolute;
                left:0;
                bottom:-1px;
                width:30%;
                background-color: #0068B7;
                height:1px;
                content:'';
                display: inline-block;
            }
            .items{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top: 60px;
                line-height: 50px;
                .item{
                    border-right: 1px solid #0068B7;
                    padding-right: 60px;
                }
                .b{
                    border: none;
                }
            }
            .enItems{
              .item{
                 width:30%;
                  padding-right: 20px;
                  text-align: center;
              }
            }
            .allImg{
                width:100%;
                margin-top: 120px;
                position: relative;
                 .swiper{
                     width:100% !important;
                     .item{
                         padding: 20px 0;
                         img{
                             width:90%;
                             object-fit: contain;
                             transition: all 600ms;
                             cursor: pointer;
                             height:300px;
                         }
                         img:hover{
                             transform: translateY(-20px);
                         }
                         p{
                             padding: 10px 0;
                             text-align: center;
                             width:90%;
                         }
                     }
                 }
                .swiper2{
                    display: none;
                }
                .btn{
                    width:30px;
                    height:30px;
                    border-radius: 50%;
                    background-color: white;
                    text-align: center;
                    i{
                        font-size: 20px;
                        color:rgba(0,0,0,.3);
                        position: absolute;
                        left:34%;
                        top:30%;
                        transform: rotate(90deg);
                        transition: all 2s;
                    }
                }
                .prev{
                    position: absolute;
                    left:-80px;
                    top:40%;
                    color:black;
                    padding:5px 5px;
                    transform: rotate(90deg);
                    cursor: pointer;
                    transition: all 2s;
                    i{
                        top:20%;
                        left:23%;
                    }
                }
                .next{
                    position: absolute;
                    right:-40px;
                    top:40%;
                    color:black;
                    padding:5px 5px;
                    transform: rotate(-90deg);
                    cursor: pointer;
                    transition: all 2s;
                    i{
                        top:15%;
                        right:30%;
                    }
                }
                .btn:hover{
                    background-color: #3B95FF;
                    color:white;
                }
                .btn:focus{
                    outline: none;
                }
            }
        }
        .bigImg{
            width:100%;
            height:100%;
            position: absolute;
            left:0;
            top:0;
            background-color: rgba(0,0,0,.8);
            z-index: 10000;
            text-align: center;
            img{
               margin-top: 30vh;
            }
        }
    }
    .jg{
        width:100%;
        position: relative;
        .bbb{
            height:1200px;
        }
        img{
            width:100%;
            object-fit: cover;
            display: block;
        }
        .add{
            position: absolute;
            top:40px;
            left:15%;
            width:1280px;
            .title{
                width:30%;
                font-size: 24px;
                font-weight: bold;
                color:white;
                border-bottom: 1px solid rgba(255,255,255,.3);
                position: relative;
                padding-bottom: 40px;
            }
            .title::before{
                position: absolute;
                content:'';
                display: inline-block;
                background-color:#0068B7;
                left:0;
                bottom:-1px;
                width:30%;
                height:2px;
            }
            img{
                margin-top: 40px;
            }
        }
        .add::before{
            display: none;
        }
    }

    @media screen and (min-width:2200px){
        .history{
            img{
                height:900px;
            }
        }
        .ry{
            .bg{
                height:900px;
            }
            .a{
                left:25%;
            }
        }
        .enry{
            .bg{
                height:1100px;
            }
        }
        .jg{
          .add{
              left:24%;
          }
        }
    }
    @media screen and (max-width: 1440px){
        .mainCon{
            .content{
                margin-top: -100px;
            }
        }
        .history{
            img{
                height:800px;
            }
            .hCon{
                .m{
                  .swiper{
                      .item{
                          .ha{
                              width:40%;
                          }
                      }
                      .item::before{
                          width:28%;
                      }
                      .item::after{
                          width:28%;
                      }
                  }
                }
            }
        }
        .ry{
            .bg{
                height:900px;
            }
            .a{
                left:5%;
                .allImg{
                    .next{
                        right:0;
                        z-index: 1000;
                    }
                    .prev{
                        left:-45px;
                    }
                }
            }
        }
        .enry{
            .bg{
                height:1050px;
            }
        }
        .jg{
            .add{
                left:3%;
            }
        }
    }
    @media screen and (max-width:1280px){
   .mainCon{
       .content{
           width:1200px;
       }
   }
        .leader{
            .m1{
                width:1200px;
            }
        }
        .ry{
            .a{
                width:1200px;
            }
        }
        .jg{
            .add{
                left:0;
                .title{
                    margin-left: 5%;
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        overflow: hidden;
       .main{
       .nav{
           width:100%;
           flex-direction: column;
           span{
               padding: 15px 0;
               width:100%;
               text-align: center;
           }
       }
   }
        .mainCon{
            .big{
                height:100px;
            }
            .content{
                width:95%;
                flex-direction: column;
                .left{
                    width:100%;
                    .a{
                        margin-top:50px;
                    }
                    .threeText{
                        flex-direction: column;
                        margin-top: 30px;
                        .item{
                            text-align: left;
                            display: flex;
                            flex-direction: row;
                            .small{
                                line-height: 40px;
                                margin-left: 30px;
                            }
                        }
                    }
                    .enthree{
                        .item{
                            width:100%;
                            margin-top: 20px;
                            .small{
                                margin-left: 0;
                            }
                            .t{
                                span:last-child{
                                    right:-150px;
                                }
                            }
                        }
                    }
                }
                .right{
                    margin-left: 0;
                    width:100%;
                    padding-top: 30px;
                }
            }
        }
        .leader{
            .ml{
                width:90%;
                .t{
                    width:50%;
                    margin-left: 25%;
                }
                .ent{
                    width:70%;
                    margin-left: 15%;
                    font-size: 20px;
                }
                .allNews{
                    .item{
                        width:100%;
                        margin-left: 0;
                        p{
                            line-height: 25px;
                            font-size: 14px;
                        }
                       .i1{
                           padding: 10px 0;
                       }
                    }
                }
            }
        }
        .history{
            img{
                height:630px;
            }
            .hCon{
                .title{
                    width:80%;
                    margin-left: 10%;
                    padding-top: 0;
                }
                .m{
                    margin-top: 100px;
                    .swiper{
                        .item{
                               .ha{
                                   width:90%;
                                   .one{
                                       padding: 20px 10px;
                                       position: relative;
                                       .o{
                                           span:nth-child(1){
                                               position: absolute;
                                               top:20px;
                                               left:20px;
                                           }
                                           span:nth-child(2){
                                               font-size: 16px;
                                           }
                                       }
                                       .r{
                                           line-height: 24px;
                                           font-size: 14px;
                                       }
                                   }
                                   .two{
                                       .time{
                                           padding-bottom: 5px;
                                       }
                                   }
                           }
                        }
                        .item::before{
                            display: none;
                        }
                        .item::after{
                            display: none;
                        }
                    }
                    .prev{
                        top:110%;
                        left:25%;
                    }
                    .next{
                        top:110%;
                        right:25%;
                    }
                    .prev,.next{
                        z-index: 100;
                    }
                }
            }
        }
        .ry{
            .bg{
                height:1100px;
            }
            .a{
                width:95%;
                left:2.5%;
                .t{
                    width:60%;
                }
                .items{
                    flex-direction: column;
                    .item{
                        padding-right: 0;
                        margin-top: 30px;
                        border-right: none;
                    }
                }
                .enItems{
                    .item{
                        width:100%;
                    }
                }
                .allImg{
                    margin-top: 0px;
                    width:90%;
                    margin-left: 5%;
                    .swiper{
                        display: none;
                        .item{
                            img{
                                width:100%;
                            }
                            p{
                                width:100%;
                                line-height: 30px;
                            }
                        }
                    }
                    .swiper2{
                        display: block;
                    }
                    .prev{
                        left:-20px;
                        z-index: 100;
                    }
                    .next{
                        right:-20px;
                        z-index: 100;
                    }
                }
            }
        }
        .enry{
            .bg{
                height:1400px;
            }
        }
        .jg{
            .bbb{
                height:500px;
            }
            .add{
                width:100%;
                img{
                    height:300px;
                    width:90%;
                    margin: 0 auto;
                    object-fit: contain;
                }
            }
        }
    }
}
</style>